import React, { useState } from 'react';
import { Modal, Form, Button } from 'antd';
import { CloseIcon } from '../../assets/icons';
import OTPInput from '../OTPInput';
import { verifyPin } from '../../services/AccountApi/profileApi';
import { toastNotify } from '../../utils/toastNotify';
import './PinModal.scss';
import { removeCookie } from '../../utils/cookies';
import { usePinRetryLockout } from '../../Hooks/usePinRetryLockout';

const PinModal = (props) => {
  const [pin, setPin] = useState(undefined);
  const [loading, setLoading] = useState(undefined);

  const {
    countDown,
    seconds,
    wrongPinCount,
    setWrongPinCount,
    disabledPinInput,
    setDisabledPinInput,
    minutes,
    remainingSeconds,
    timerCounter,
    fiveMinTimeCounter,
  } = usePinRetryLockout();

  const handleVerifyPin = async () => {
    setLoading(true);
    let formData = {
      pin: pin,
      pinVerificationType: 'profileEdit',
    };
    try {
      const response = await verifyPin(formData);
      if (!response.isError) {
        props.clickAction();
        localStorage.removeItem('wrongOtpCount');
        setWrongPinCount(0);
        setPin(undefined);
      } else {
        if(response?.data?.data?.loginRetryAttempt === 1){
          localStorage.setItem('wrongOtpCount',0)
      }
      if(response?.data?.data?.loginRetryAttempt === 2){
          localStorage.setItem('wrongOtpCount',1)
      }
        if (response?.data?.data?.loginRetryAttempt === 3) {
          localStorage.setItem('wrongOtpCount', 2);
          setDisabledPinInput(true);
          timerCounter();
          localStorage.setItem('pinRetriesTimeCounter', new Date().getTime())
        }
        if (response?.data?.data?.loginRetryAttempt === 4) {
          localStorage.setItem('wrongOtpCount', 4)
          setDisabledPinInput(true);
          fiveMinTimeCounter();
          localStorage.setItem('pinRetriesTimeCounter', new Date().getTime())
        }
        if (response?.data?.data?.loginRetryAttempt === 5) {
          localStorage.clear();
          localStorage.removeItem('redirectIntendedPage');
          removeCookie();
          window.location.href = '/login'
        }
        toastNotify('error', response?.data?.message);
        setPin(undefined);
      }
    } catch (error) {
      const { response } = error;
      if(response?.data?.data?.loginRetryAttempt === 1){
        localStorage.setItem('wrongOtpCount',0)
    }
    if(response?.data?.data?.loginRetryAttempt === 2){
        localStorage.setItem('wrongOtpCount',1)
    }
      if (response?.data?.data?.loginRetryAttempt === 3) {
        localStorage.setItem('wrongOtpCount', 2);
        setDisabledPinInput(true);
        timerCounter();
        localStorage.setItem('pinRetriesTimeCounter', new Date().getTime())
      }
      if (response?.data?.data?.loginRetryAttempt === 4) {
        localStorage.setItem('wrongOtpCount', 4)
        setDisabledPinInput(true);
        fiveMinTimeCounter();
        localStorage.setItem('pinRetriesTimeCounter', new Date().getTime())
      }
      if (response?.data?.data?.loginRetryAttempt === 5) {
        localStorage.clear();
        localStorage.removeItem('redirectIntendedPage');
        removeCookie();
        window.location.href = '/login'
      }
      if (wrongPinCount === 4) {
        localStorage.clear();
        removeCookie();
        window.location.href= '/login'
    }
      toastNotify('error', response?.data?.message);
      setPin(undefined);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      className='pinmodal'
      open={props.setOpen}
      onCancel={() => {
        props.setClose();
        setPin(undefined);
      }}
      closeIcon={<CloseIcon />}
      footer={false}
      width={524}
      centered
    >
      <h4 className='mb-40 text-center pinmodal__title'>Enter your 4-digit PIN</h4>
      <Form
        className='signup-form pin-form'
        onKeyPress={(e) => {
          if (pin?.length === 4 && e.key === 'Enter') {
            handleVerifyPin();
          }
        }}
      >
        <OTPInput
          length={4}
          onChangeOTP={(otp) => setPin(otp)}
          onClearOtp={pin}
          otp={pin}
          disabled={loading || disabledPinInput}
          className='mb-48 otp'
          autoFocus
          inputClassName='otp__input'
        />
        {props.children}
        {countDown > 0 && <div className='mb-10 fw-500 text-center'>You can retry after {countDown} seconds</div>}
        {seconds < 300 && seconds > 0 && (
          <div className='mb-10 fw-500 text-center'>
            You can retry after {minutes > 0 && `${minutes} minutes `}
            {remainingSeconds < 60
              ? `${remainingSeconds} seconds`
              : `${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds} seconds`}
          </div>
        )}
        <Form.Item className='mb-0'>
          <Button type='primary' className='w-100' loading={loading} onClick={handleVerifyPin} disabled={!pin || pin?.length < 4 || disabledPinInput}>
            Confirm
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PinModal;
